import { render, staticRenderFns } from "./projectCompany.vue?vue&type=template&id=5e5881a4&scoped=true&"
import script from "./projectCompany.vue?vue&type=script&lang=js&"
export * from "./projectCompany.vue?vue&type=script&lang=js&"
import style0 from "./projectCompany.vue?vue&type=style&index=0&id=5e5881a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5881a4",
  null
  
)

export default component.exports